import React from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';

const Container = styled('div')(({ theme }) => ({
  width: '100%',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const CashbackDisclaimer = () => {
  const { t } = useTranslation();

  return <Container>{t('cashbackCalculator.detailed.cashbackDisclaimer.label')}</Container>;
};
